@if (toolbarItems.length) {
  <div id="add-toolbar-popover">
    @for (item of toolbarItems; track item) {
      <button (click)="handleEvent(item.event)">
        <span
          class="tool-text-container"
          [attr.data-testid]="'flowchart-add-node-popover_button-' + item.titleKey.split('.Add')[1].toLowerCase()">
          <span class="tool-title">{{ item.titleKey | transloco }}</span>
          <span class="tool-description">{{ item.descriptionKey | transloco }}</span>
        </span>
        <span class="tool-image">
          <img alt="Icon" src="{{ item.icon }}" />
        </span>
      </button>
    }
  </div>
}
